<template>
    <div class="table-responsive tabelageralnew">
        <loading :show="show" :label="label" :overlay="overlay"></loading>
        <div class="barra_botoes_exportar">
            <span class="titulo_btnexport">Exportar para: </span>
            <download-excel class="btn_exportnew"
            :title="tituloexport"
            :fetch="fetchData"
            :fields="dadostitulo"
            :name="nomearquivo+'.xls'">
                <img alt="Exportar para xls" title=".xls" src="../../../assets/images/icon_xls.png">
            </download-excel>
            <download-excel class="btn_exportnew"
            :title="tituloexport"
            :fetch="fetchData"
            :fields="dadostitulo"
            type="csv"
            :name="nomearquivo+'.csv'">
                <img alt="Exportar para csv" title=".csv" src="../../../assets/images/icon_csv.png">
            </download-excel>
            <download-excel class="btn_exportnew"
            :title="tituloexport"
            :fetch="fetchData"
            :fields="dadostitulo"
            :name="nomearquivo+'.doc'">
                <img alt="Exportar para dpc" title=".doc" src="../../../assets/images/icon_doc.png">
            </download-excel>
            <div class="btn_exportnew"><a v-on:click="exportarpdf()">
                <img alt="Exportar para pdf" title=".pdf" src="../../../assets/images/icon_pdf.png">
            </a></div>
        </div>
        <table class="table table-striped">
            <thead class="">
                <tr>
                    <th width="134px" style="text-align:center !important;">Data Publicação</th>
                    <th width="65px" style="text-align:center !important;">Edição</th>
                    <th>Descrição</th>
                    <th width="45px" style="text-align:center !important;"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="itens in dadosconteudo.tr">
                    <td style="text-align:center !important; vertical-align: top !important;">{{itens.datapublicacao}}</td>
                    <td style="text-align:center !important; vertical-align: top !important;">
                        <a :href="itens.linkarquivo" title="Visualizar arquivo" target="_blank">            {{{itens.edicao}}}
                        </a>
                    </td>
                    <td style="text-align:left !important;">
                        <p class="descitemclass" v-for="desciten in itens.descricao">{{{desciten.item}}}</p>
                        <!--<p v-if="itens.tipo == 'NOVO' && itens.semassinatura != true" >*Arquivo assinado digitalmente, <a @click="loadmodal(itens.infomodal)" data-toggle="modal" :data-target="'#'+itens.infomodal">clique aqui</a> para obter detalhes.</p>-->
                        <p v-if="itens.tipo == 'NOVO' && itens.semassinatura != true" >*Arquivo assinado digitalmente.</p>
                        <p v-if="itens.tipo != 'NOVO' && itens.semassinatura != true" >*Arquivo assinado digitalmente - {{itens.origem}}.</p>                        
                    </td>
                    <td style="text-align:center !important;">
                        <div v-if="itens.linkassinatura != ''">
                        <a v-if="itens.downonlyp7s == false" :href="itens.linkarquivo" :id="'down-pdf-'+itens.infomodal" download target="_blank"></a> 
                        <a :href="itens.linkassinatura" :id="'down-p7s-'+itens.infomodal" download></a> 
                        <a v-if="itens.downonlyp7s == false" :href="'javascript:MPL.downFiles('+itens.infomodal+');'" title="Baixar arquivos (PDF e p7s)">
                            <img src="../../../assets/icones/1487035083_document-edit.png" >
                        </a>
                        <a v-else :href="'javascript:MPL.downFiles('+itens.infomodal+');'" title="Baixar arquivo (p7s)">
                            <img src="../../../assets/icones/1487035083_document-edit.png" >
                        </a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="text-center">
            <cp-paginate :source="dadosconteudo" @navigate="navigate"><cp-paginate>
         </div>
                    <!-- Modal de informações -->
                    <div v-if="visible == true">
                        <info-modal :line="dadosmodal.infomodal" :dadosmodal="dadosmodal" :certificado="certificado" :emissorum="emissorum" :emissordois="emissordois" :emissortreis="emissortreis" :atributos="atributos"></info-modal>
                    </div>                    
                    <!-- fim Modal de informações -->
</div>
                    </template>
                    <script>
import InfoModal from "./modal/infomodal.vue";
import downloadExcel from "vue-json-excel";
import loading from "vue-full-loading";
import CpPaginate from "../../pagination/pagination.vue";

export default {
  data() {
    return {
      dadostable: {},
      dadosmodal: {},
      certificado: {},
      emissorum: {},
      emissordois: {},
      emissortreis: {},
      atributos: {},
      infomodal: {},
      visible: false,
      nomearquivo: "",
      tituloexport: "",
      dadosexportar: {},
      dadostitulo: {
        "Data Publicação": "datapublicacao",
        Edição: "edicao",
        "Link Edição": {
          field: "linkarquivo",
          callback: (value) => {
            return `<a href="${value}">Download</a>`;
          },
        },
        Descrição: {
          field: "descricao",
          callback: (value) => {
            var desctotais = [];
            for (var i = 0; i < value.length; i++) {
              desctotais.push(value[i].item + "<br>");
            }
            return desctotais;
          },
        },
      },
      json_meta: [[{ key: "charset", value: "utf-8" }]],
      show: false,
      label: "Gerando arquivo...",
      overlay: true,
    };
  },
  components: {
    InfoModal,
    CpPaginate,
    downloadExcel,
    loading,
  },
  ready() {
    $(".table-responsive").fadeOut("fast");
  },
  watch: {
    $route() {
      $(".table-responsive").fadeOut("fast");
    },
  },
  props: ["dadosconteudo"],
  methods: {
    fetchData() {
      $.ajaxSetup({
        async: false,
      });

      var self = this;
      var page = "-1";
      MPL.loadDadosDiarios(page, function (dados) {
        self.dadosexportar = dados[0].tr;

        /*for(var i = 0; i < self.dadosconteudo.tr.length;i++) {
													self.dadosexportar.tr[i].descricao[0].item = self.dadosconteudo.tr[i].descricao[0].item.replace(/<br>/gi, '<p class="newp"></p>')
												}*/
        //console.log(self.dadosconteudo)
      });

      $.ajaxSetup({
        async: true,
      });

      this.tituloexport = window.dadosconteudogeral.titulopagina;
      var tit = this.tituloexport[0];

      tit = tit.split(/\s*\\s*/);
      tit = tit[0].replace(/\s/g, "");
      //console.log(tit)
      this.nomearquivo = tit;
      return self.dadosexportar;
    },
    exportarpdf() {
      this.show = true;
      // $.ajaxSetup({
      //     async: false
      // });

      var exportpdf = [];
      var self = this;
      var page = "-1";
      MPL.loadDadosDiarios(page, function (dados) {
        exportpdf = dados[0].tr;
        for (var e = 0; e < exportpdf.length; e++) {
          var newdesc = [];
          for (var p = 0; p < exportpdf[e].descricao.length; p++) {
            // console.log(exportpdf[e].descricao[p].item)
            newdesc.push(exportpdf[e].descricao[p].item + "\n\n");
          }
          exportpdf[e].descricao = newdesc;
        }

        var colunas = [
          { title: "Data Publicação", dataKey: "datapublicacao" },
          { title: "Edição", dataKey: "edicao" },
          { title: "Descrição", dataKey: "descricao" },
        ];

        var doc = new jsPDF("l", "pt");

        var titulopdf = window.dadosconteudogeral.titulopagina;
        var tit = titulopdf[0];
        tit = tit.split(/\s*\\s*/);
        tit = tit[0].replace(/\s/g, "");
        self.nomearquivo = tit;

        doc.autoTable(colunas, exportpdf, {
          styles: { overflow: "linebreak" },
          columnStyles: {
            datapublicacao: { columnWidth: 70 },
            edicao: { columnWidth: 80, halign: "center" },
          },
          addPageContent: function (data) {
            doc.text(titulopdf, 40, 30);
          },
        });

        doc.save(self.nomearquivo + ".pdf");

        self.show = false;
      });

      // $.ajaxSetup({
      //     async: true
      // });
      //console.dir(exportpdf)
    },
    navigate(page) {
      $.ajaxSetup({
        async: false,
      });

      var self = this;

      MPL.loadDadosDiarios(page, function (dados) {
        //self.dadosconteudo = dados[0];
        self.dadosconteudo = dados[0];
        self.dadostable = dados[0];
        //alert(self.$route.params.tipo)
        //console.log(self.dadosconteudo)
        for (var i = 0; i < self.dadosconteudo.tr.length; i++) {
          self.dadosconteudo.tr[i].descricao[0].item = self.dadosconteudo.tr[
            i
          ].descricao[0].item.replace(/<br>/gi, '<p class="newp"></p>');
        }
      });

      $.ajaxSetup({
        async: true,
      });
    },
    loadmodal(id) {
      //Metronic.blockUI();
      $.ajaxSetup({
        async: false,
      });

      var self = this;

      self.visible = true;

      $.getJSON(
        "../../transparencia/server/assinatura.php",
        { id: id },
        function (dados) {
          //self.dadosconteudo = dados[0];
          self.dadosmodal = dados[0];
          self.certificado = self.dadosmodal.certificado[0];
          self.emissorum = self.certificado.emissor1[0];
          self.atributos = self.dadosmodal.atributosassinados[0];
          //Metronic.unblockUI();
          //alert(self.$route.params.tipo)
          //console.log(dados[0].conteudo)
        }
      );

      $.ajaxSetup({
        async: true,
      });
    },
  },
};
</script>

                    <style type="text/css" scoped>
.descitemclass {
  margin-bottom: 5px;
  margin-top: 0;
}

.arquivo_assinado {
  margin-bottom: 0px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// table.vue?5d1e5814